import { createTheme } from '@mui/material';
import { green, grey, lightBlue, orange } from '@mui/material/colors';
import DarkTheme from './DarkTheme';

let LightTheme = createTheme({
  palette: {
    mode: 'light',
    myWarning: 'rgba(255, 200, 40,0.6)',
    grey: {
      800: '#E3E3E3',
    },
  },
  typography: {
    subtitle1: {
      textTransform: 'none',
    },
    fontFamily: ['arial', 'helvetica', 'sans-serif'].join(','),
  },
});

LightTheme = createTheme(LightTheme, {
  status: {
    danger: orange[500],
  },
  palette: {
    buttonColor: DarkTheme.palette.augmentColor({
      color: {
        main: '#BDBDBD',
      },
    }),
    consentButtonColor: LightTheme.palette.augmentColor({
      color: {
        main: '#42526E',
        background: '#E3F2FD',
      },
    }),
    borderColor: LightTheme.palette.augmentColor({
      color: {
        // TODO: Change to grey ['300'] when core is killed
        main: 'rgb(204, 204, 204)',
      },
    }),
    subHeaderColor: LightTheme.palette.augmentColor({
      color: {
        main: '#EBF6FC',
      },
    }),
    sidebarColor: LightTheme.palette.augmentColor({
      color: {
        main: grey['50'],
      },
    }),
    notStarted: LightTheme.palette.augmentColor({
      color: {
        main: grey['100'],
      },
    }),
    inProgress: LightTheme.palette.augmentColor({
      color: {
        main: lightBlue['100'],
      },
    }),
    finished: LightTheme.palette.augmentColor({
      color: {
        main: green['100'],
      },
    }),
  },
});

export default LightTheme;
